





























































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { library, IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

import { POAExtensionService } from '@/services/POAExtensionService';
import POAExtensionRecord from '@/entities/POAExtensionRecord';
import axios, { AxiosError, AxiosResponse } from 'axios';
import POAExtensionRecordDisplay from '@/components/POAExtensionRecordDisplay.vue';
import HelpModal from '@/components/HelpModal.vue';
import ScrollAndShow from '@/utility/Scrolling';

library.add(faSpinner as IconDefinition);

@Component({
  components: {
    POAExtensionRecordDisplay,
    FontAwesomeIcon,
    HelpModal,
  },
})
export default class POALookup extends Vue {
  private clean: boolean = true;
  private tooMany: boolean = false;
  private disabled: boolean = false;
  private showSearch: boolean = false;
  private name: string = '';
  private nameDirty: boolean = false;
  private ticket: string = '';
  private ticketDirty: boolean = false;
  private tickets: POAExtensionRecord[] = [];
  private updateTrigger: number = 0;
  private foundTicket: boolean = false;
  private labels: string[] = [];
  private links: string[] = [];

  public get locale(): string {
    return this.$i18n.locale;
  }

  @Watch('locale')
  public onLocaleChange(value: string, oldVal: string) {
    this.setPageHead();
    this.setBreadcrumbs();
  }

  public mounted() {
    this.setPageHead();
    this.setBreadcrumbs();
  }

  public setBreadcrumbs() {
    this.labels = [
      this.$t('homeTitle').toString(),
      this.$t('transTitle').toString(),
      this.$t('parkingTitle').toString(),
      this.$t('breadTitle').toString(),
    ];
    this.links = [
      this.$t('homeUrl').toString(),
      this.$t('transUrl').toString(),
      this.$t('parkingUrl').toString(),
    ];
    this.$store.commit('setLabels', this.labels);
    this.$store.commit('setLinks', this.links);
  }

  public setPageHead() {
    if (this.$el.ownerDocument !== null) {
      this.$el.ownerDocument.title = this.$t('pageTitle').toString();
    }
  }

  public searchForTickets() {
    this.nameDirty = this.ticketDirty = true;
    // Only search if there are no validation errors
    if (this.getFormErrors) {
      // Focus on the error list - use a `setTimeout` so that the web component
      // has a chance to render the markup.
      setTimeout(() => {
        const errorList = this.$refs.errorlist as HTMLSelectElement;
        if (errorList) {
          const errorListSection = errorList.getElementsByTagName('section');
          if (errorListSection && errorListSection.length > 0) {
            ScrollAndShow(errorListSection[0]);
          }
        }
      }, 100);
    } else {
      this.disabled = true;
      this.showSearch = true;

      POAExtensionService.search(this.name, this.ticket)
        .then((response: AxiosResponse<POAExtensionRecord[]>) => {
          const data: POAExtensionRecord[] = response.data;
          this.tickets = [];
          for (const ticket of data) {
            this.tickets.push(ticket);
          }
          this.foundTicket = this.tickets.length > 0;
          this.clean = true;
          this.tooMany = false;
        })
        .catch((err) => {
          if (err.message.includes('Network Error')) {
            this.clean = false;
          } else if (
            err.response.status === 400 &&
            err.response.data.message.includes('Too many records')
          ) {
            this.tooMany = true;
          }
        })
        .finally(() => {
          this.disabled = false;
        });
    }
  }

  private updateErrors() {
    // Update a data member that can be referenced inside a computed method so errors
    // can show on blur events
    this.updateTrigger++;
  }

  private get getFormErrors() {
    // Wrap the error logic so that the blur events will trigger error immediately
    if (this.updateTrigger >= 0) {
      let numErrors: number = 0;
      const errorMessages: string[] = [];
      const errorTargetIds: string[] = [];

      const errorMessage = this.checkNameError();
      if (errorMessage) {
        numErrors++;
        errorMessages.push(errorMessage);
        errorTargetIds.push('poa-name-filter');
      }

      const tiketErrorMessage = this.checkTicketError();
      if (tiketErrorMessage) {
        numErrors++;
        errorMessages.push(tiketErrorMessage);
        errorTargetIds.push('poa-number-filter');
      }

      if (numErrors > 0) {
        return {
          count: numErrors,
          heading: this.$tc('nErrorsWereFound', numErrors),
          errors: errorMessages,
          targets: errorTargetIds,
        };
      }
    }
    return null;
  }

  private checkNameError() {
    if (this.nameDirty && (this.name === null || this.name.length === 0)) {
      if (
        document.activeElement &&
        document.activeElement.id !== 'poa-name-filter'
      ) {
        return `${this.$t('theField')} "${this.$t('nameLabel')}" ${this.$t(
          'isRequired',
        )}`;
      }
    }
    if (this.nameDirty && (this.name !== null && this.name.length < 2)) {
      if (
        document.activeElement &&
        document.activeElement.id !== 'poa-name-filter'
      ) {
        return `${this.$t('theField')} "${this.$t('nameLabel')}" ${this.$t(
          'tooShort',
        )}`;
      }
    }
    return '';
  }

  private checkTicketError() {
    const ticketDom = document.getElementById('poa-number-filter');
    if (
      this.ticketDirty &&
      (this.ticket === null || this.ticket.length === 0)
    ) {
      if (
        document.activeElement &&
        document.activeElement.id !== 'poa-number-filter'
      ) {
        if (ticketDom) {
          ticketDom.classList.add('ott-input-error');
        }
        return `${this.$t('theField')} "${this.$t('ticketLabel')}" ${this.$t(
          'isRequired',
        )}`;
      }
    } else {
      if (ticketDom) {
        ticketDom.classList.remove('ott-input-error');
      }
      return '';
    }
  }
}
